<template>
  <div @click="trigger">
    <slot />
  </div>
</template>
<script lang="ts" setup>
const trigger = inject('trigger') as () => void
</script>
